import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getSaved = createAsyncThunk(
  "saved/getSaved",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, type = "PROPERTY", user } = args;
      let url = `/favourites?page=${page}&size=${size}&type=${type}`;

      if (user) {
        url += `&user=${user}`;
      }

      const { data } = await axiosInstance.get(url);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const savedSlice = createSlice({
  name: "saved",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getSaved.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getSaved.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data.data;
        state.itemsCount = payload.data.itemsCount;
        state.pages = payload.data.pages;
      })
      .addCase(getSaved.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default savedSlice.reducer;